import { messages } from '../../Messages';

export const FORM_STEPS_KEYS = [
  `${messages.repairBookingForm.warrantyCheck.header}`,
  `${messages.repairBookingForm.documentationCheck.header}`,
  `${messages.repairBookingForm.contactDetails.header}`,
  `${messages.repairBookingForm.productDetails.header}`,
  `${messages.repairBookingForm.damageDetails.header}`,
  `${messages.repairBookingForm.pickupDetails.header}`,
  `${messages.repairBookingForm.returnDetails.header}`,
  `${messages.repairBookingForm.summary.header}`,
];
export const FORM_STEPS = [
  'Warranty Check',
  'Documentation Check',
  'Contact Details',
  'Product Details',
  'Damage Details',
  'Pick-Up Details',
  'Return Details',
  'Summary',
];

export const PostNordPickupProductMap: { [key: string]: string } = {
  "11":"Home pickup",
  "92":"Drop to Postnord Parcel Locker",
  "19":"Drop to Postnord Service Point",
  "32":"Home pickup"
}

export const PostNordReturnProductMap :  { [key: string]: string }  = {
  "11":"Home delivery",
  "92":"Pick from Postnord Parcel Locker",
  "19":"Pick from Postnord Service Point",
  "32":"Home delivery"
}

export enum FORM_STEPS_ENUM {
  warrantyCheck = 'Warranty Check',
  documentationCheck = 'Documentation Check',
  contactDetails = 'Contact Details',
  productDetails = 'Product Details',
  damageDetails = 'Damage Details',
  pickupDetails = 'Pick-Up Details',
  returnDetails = 'Return Details',
  summary = 'Summary',
}

export type FormDataType = {
  serviceType: string;
  receipt: string;
  receiptAvailable: boolean;
  returnProduct: boolean;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  streetName: string;
  streetNumber?: string;
  postalCode: string;
  city: string;
  country: string;
  modelName?: string;
  modelNumber?: string;
  productionCode?: string;
  isLabelsMissing: boolean;
  productCategory: string;
  productSubCategory: string;
  categoryId: number;
  subCategoryId: number;
  damageDetails: Array<any>;
  comments: string;
  damagedProductImages: Array<any>;
  dropLocation: string;
  productUnderWarranty: boolean;
  totalCost: number;
  amountPaid: number;
  productInfo: boolean;
  repairerId: number;
  shippingCost: string;
  coveredUnderWarranty: number;
  pickUpDate: string;
  pickUpTime: string;
  deliveryDate: string;
  deliveryTime: string;
  logisticsData: string;
  deliverylogisticsData: string;
  discountCode: string;
  discountedAmount: number;
  integrationID: string;
};

export const formDefaultValues = {
  serviceType: '',
  receipt: '',
  receiptAvailable: false,
  returnProduct: false,
  firstName: '',
  lastName: '',
  phoneNumber: '',
  email: '',
  streetName: '',
  streetNumber: '',
  postalCode: '',
  city: '',
  country: undefined,
  modelName: '',
  modelNumber: '',
  productionCode: '',
  isLabelsMissing: false,
  productCategory: '',
  productSubCategory: '',
  categoryId: 0,
  subCategoryId: 0,
  damageDetails: [],
  comments: '',
  damagedProductImages: [],
  totalCost: 0,
  amountPaid: 0,
  dropLocation: JSON.stringify({ name: '', id: '' }),
  productUnderWarranty: false,
  productInfo: false,
  repairerId: 0,
  shippingCost: '0',
  coveredUnderWarranty: 0,
  pickUpDate: '',
  pickUpTime: '',
  deliveryDate: '',
  deliveryTime: '',
  logisticsData: '',
  deliverylogisticsData: '',
  discountCode: '',
  discountedAmount: 0,
  integrationID: '',
};

export enum OrderStatus {
  DRAFT = 1,
  PLACED = 2,
}
